import { createAction } from '@reduxjs/toolkit';

export interface IEarlyAccessCounterData {
  /** Текст баннера раннего доступа к объявлению */
  text: string;
}

export type IEarlyAccessCounterState = IEarlyAccessCounterData | null;

export type TEarlyAccessCounterAction = {
  type: 'earlyAccessCounter/setData';
  payload: IEarlyAccessCounterState;
};

const initialState: IEarlyAccessCounterState = null;

export const setEarlyAccessCounterData = createAction<IEarlyAccessCounterState>('earlyAccessCounter/setData');

export function earlyAccessCounterReducer(
  state: IEarlyAccessCounterState = initialState,
  action: TEarlyAccessCounterAction,
): IEarlyAccessCounterState {
  switch (action.type) {
    case 'earlyAccessCounter/setData':
      return action.payload;
    default:
      return state;
  }
}
